import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["id", "aria-controls", "aria-selected", "aria-disabled", "onClick"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { SpriteIcons } from '@/user/components/common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PillTabs',
    props: {
        className: { default: undefined },
        color: { default: 'default' },
        hasButton: { type: Boolean, default: false },
        buttonIconName: { default: undefined },
        tabs: {},
        ariaLabel: { default: '탭 목록' }
    },
    emits: ["tabClick", "update:activeTab", "optionClick"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const input = tv({
            slots: {
                tabsCover: clsx('relative overflow-hidden', '', ''),
                tabsInner: clsx('flex gap-4 overflow-y-auto px-16', 'gap-4', 'desktop:gap-8 desktop:px-0'),
                tabItem: clsx('flex items-center whitespace-nowrap rounded-full px-20 py-9 hover:bg-gray-500/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:text-gray-300', 'text-m-title-2', 'desktop:text-title-3 desktop:px-24 desktop:py-8'),
                tabCountStyle: clsx('', 'ml-4', 'desktop:ml-6'),
                optionButton: clsx('desktop:hidden absolute right-0 top-1/2 -translate-y-1/2 transform bg-white p-16 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500'),
                optionButtonGradient: clsx('-z-1 absolute inset-0 -left-16 h-full w-16 bg-gradient-to-r from-transparent to-white'),
            },
            variants: {
                color: {
                    default: '',
                    teal: '',
                    violet: '',
                    mutedBlue: '',
                },
                isActive: {
                    true: {
                        tabItem: '',
                    },
                    false: {
                        tabItem: 'text-gray-600',
                    },
                },
            },
            compoundVariants: [
                {
                    color: 'default',
                    isActive: true,
                    class: {
                        tabItem: 'bg-blue-700/10 text-blue-700 hover:bg-blue-700/10',
                    },
                },
                {
                    color: 'teal',
                    isActive: true,
                    class: {
                        tabItem: 'bg-teal-700/10 text-teal-700 hover:bg-teal-700/10',
                    },
                },
                {
                    color: 'violet',
                    isActive: true,
                    class: {
                        tabItem: 'bg-violet-700/10 text-violet-700 hover:bg-violet-700/10',
                    },
                },
                {
                    color: 'mutedBlue',
                    isActive: true,
                    class: {
                        tabItem: 'bg-muted-blue-700/10 text-muted-blue-700 hover:bg-muted-blue-700/10',
                    },
                },
            ],
            defaultVariants: {
                color: 'default',
                isActive: false,
            },
        });
        const handleTabClick = (tab) => {
            emit('tabClick', tab);
            emit('update:activeTab', tab.id);
        };
        const handleOptionClick = () => {
            emit('optionClick');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "aria-label": props.ariaLabel,
                class: _normalizeClass(_unref(clsx)(_unref(input)().tabsCover(), props.className, props.hasButton ? 'pr-56' : '')),
                role: "tablist"
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(_unref(clsx)(_unref(input)().tabsInner()))
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (tab) => {
                        return (_openBlock(), _createElementBlock("button", {
                            id: tab.id,
                            key: tab.id,
                            "aria-controls": `${tab.id}-panel`,
                            "aria-selected": tab.isActive,
                            "aria-disabled": tab.disabled,
                            class: _normalizeClass(_unref(clsx)(_unref(input)({
                                color: props.color,
                                isActive: tab.isActive,
                            }).tabItem())),
                            role: "tab",
                            type: "button",
                            onClick: ($event) => (handleTabClick(tab))
                        }, [
                            _createTextVNode(_toDisplayString(tab.text) + " ", 1),
                            (tab.tabCount)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    "aria-label": "탭 항목 수",
                                    class: _normalizeClass(_unref(clsx)(_unref(input)().tabCountStyle()))
                                }, _toDisplayString(tab.tabCount), 3))
                                : _createCommentVNode("", true)
                        ], 10, _hoisted_2));
                    }), 128))
                ], 2),
                (props.hasButton)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        "aria-label": 'Menu Open',
                        class: _normalizeClass(_unref(clsx)(_unref(input)().optionButton())),
                        type: "button",
                        onClick: handleOptionClick
                    }, [
                        _createElementVNode("span", {
                            class: _normalizeClass(_unref(clsx)(_unref(input)().optionButtonGradient()))
                        }, null, 2),
                        _createVNode(_unref(SpriteIcons), {
                            "aria-hidden": "true",
                            class: "h-24 w-24",
                            name: props.buttonIconName
                        }, null, 8, ["name"])
                    ], 2))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_1));
        };
    }
});
